
import Link from '@/components/common/Link'
import { getMessage } from '@/utils/messages'
import { URLS } from '@/constants'

export default function LockedAccountAlertContent() {
  const link = (
    <Link size="xsmall" to={URLS.helpCenter} external openTab>
      {getMessage('login.lockedError.link')}
    </Link>
  )

  return <p>{getMessage('login.lockedError.content')}&nbsp;{link}</p>
}
